// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1VLgv","buttons":"RemoveExpirationActionButtons_buttons__3TeVc"};